import React from 'react';
import { FaGlobe, FaFileArchive } from 'react-icons/fa';

const Solutions = () => {
  const solutions = [
    { icon: <FaGlobe />, title: 'ConnectMe', description: 'Связывайтесь с пользователями по всему миру без проблем.', link: 'https://connect-me.hisphere.net' },
    { icon: <FaFileArchive />, title: 'HiZip', description: 'Упаковывает файлы — распаковывает нервы. Работает мгновенно, выглядит как будущее.', link: '/HiZip Setup 1.0.0.exe' }
  ];

  return (
    <section id='solutions' className='py-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-top-80 before:-right-80 before:w-[800px] before:h-[800px] before:bg-gradient-radial before:from-blue-500/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='text-center mb-20 animate'>
          <h2 className='text-5xl font-montserrat font-bold bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent relative mb-6
            after:content-[""] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-gradient-to-r after:from-pink-500 after:to-purple-600 after:rounded'>
            Наши решения
          </h2>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto'>
            Откройте для себя мощные функции, которые выделяют нашу платформу.
          </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {solutions.map((feature, index) => (
            <div
              key={index}
              className='feature-card bg-white dark:bg-gray-800/70 border border-gray-100 dark:border-gray-700 rounded-2xl p-6 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300 relative overflow-hidden animate
                before:content-[""] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-blue-500 before:to-indigo-800 before:transition-all before:duration-300 hover:before:w-2 hover:before:bg-gradient-to-b hover:before:from-pink-500 before:to-purple-600'
            >
              <div className='w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-800 rounded-xl flex items-center justify-center text-white text-2xl mb-4 transition-all duration-300 hover:rotate-12 hover:scale-110 hover:bg-gradient-to-br hover:from-pink-500 hover:to-purple-600 hover:shadow-lg'>
                {feature.icon}
              </div>
              <h3 className='text-xl font-montserrat font-bold mb-2 text-gray-900 dark:text-white relative
                after:content-[""] after:absolute after:bottom-[-5px] after:left-0 after:w-0 after:h-0.5 after:bg-pink-500 after:transition-all after:duration-300 group-hover:after:w-full'>
                {feature.title}
              </h3>
              <p className='text-gray-600 dark:text-gray-400 mb-4'>{feature.description}</p>
              {!!feature.link ? (
                <a
                  href={feature.link}
                  target='_blank'
                  className='inline-flex items-center text-blue-500 font-semibold hover:text-pink-500 transition-all duration-200 group'
                >
                  Перейти
                </a>
              ) : (
                <button
                  disabled
                  className='inline-flex items-center text-gray-400 font-semibold cursor-not-allowed transition-all duration-200 group'
                >
                  Скоро...
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
